import axios from 'axios';
import React, {useState, useEffect} from 'react';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';

export const MiPerfilInferior = (props) => {
	const {
		modalBorrrarCuenta,
		setModalBorrrarCuenta,
		modalGuardarCambios,
		setModalGuardarCambios,
		UsuarioCambiar,
		onInputChange,
		modificar,
		setModificar,
	} = props;

	const modificarDatos = () => {
		setModificar(true);
		var inputs = document.getElementsByClassName('inputModificar');
		for (var i = 0; i < inputs.length; i++) {
			inputs[i].disabled = false;
		}
	};


	return (
		<div className='miPerfilInferior bg-light my-2 shadow-sm'>
			<div className='contentMiPerfilInferior bg-light'>
				
				<div className='my-1'>
					<div className='labelDatoFormUsu'>Nombre</div>
					<div className='mt-1'>
						<input
							type='text'
							className='form-control text-dark'
							name='nombre'
							placeholder='Nombre'
							onChange={(event) => onInputChange(event)}
							value={UsuarioCambiar.nombre}
							disabled={!modificar}
						/>
					</div>
				</div>
				<div className='my-1'>
					<div className='labelDatoFormUsu'>Apellidos</div>
					<div className='mt-1'>
						<input
							type='text'
							className='form-control text-dark'
							name='apellidos'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.apellidos}
							disabled={!modificar}
						/>
					</div>
				</div>
				<div className='my-1'>
					<div className='labelDatoFormUsu'>Email</div>
					<div className='mt-1'>
						<input
							type='email'
							name='email'
							className='form-control text-dark'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.email}
							disabled={!modificar}
						/>
					</div>
				</div>
				<div className='my-1'>
					<div className='labelDatoFormUsu'>Teléfono</div>
					<div className='mt-1'>
						<input
							type='text'
							className='form-control text-dark'
							name='telefono'
							onChange={(e) => onInputChange(e)}
							value={UsuarioCambiar.telefono}
							disabled={!modificar}
						/>
					</div>
				</div>
			</div>
			{/* <div className='separador' />
			<div className='buttonsMiPerfil'>
				<div
					className='button borrarCuenta'
					onClick={() => setModalBorrrarCuenta(true)}
					//onClick={() => eliminarPerfil(UsuarioCambiar)}
				>
					<b>Borrar cuenta</b>
				</div>
				<div
					className='button'
					onClick={
						modificar ? () => setModalGuardarCambios(true) : () => modificarDatos()
					}
				>
					<b>{modificar ? 'Guardar' : 'Modificar'}</b>
				</div>
			</div> */}
		</div>
	);
};
